import axios from "./axios";

export const getFavorites = async () => {
  const response = await axios.get("/favorites");
  return response.data;
};

export const getFavoriteCategories = async () => {
  const response = await axios.get("/favorites/categories");
  return response.data;
};

export const getFavoritesByCategory = async (categoryId, limit = 20, offset = 0) => {
  const response = await axios.get(`/favorites/category/${categoryId}`, {
    params: { limit, offset }
  });
  return response.data;
};

export const getFavoriteIds = async () => {
  const response = await axios.get("/favorites/ids");
  return response.data;
};

export const addFavorite = async (elementId, customPrice = null) => {
  const response = await axios.post(`/favorites/${elementId}`, { customPrice });
  return response.data;
};

export const removeFavorite = async (elementId) => {
  const response = await axios.delete(`/favorites/${elementId}`);
  return response.data;
};

export const updateFavoritePrice = async (elementId, customPrice) => {
  const response = await axios.patch(`/favorites/${elementId}/price`, { customPrice });
  return response.data;
};
